
import { computed, onMounted, ref } from 'vue';
import Button from 'primevue/button';
import Message from 'primevue/message';
import { game } from '../apis/game';
import { GamesList, GameStatusResult, ListByGameTypeResult } from '../types/game';
import GameNavbar from '../components/navbar/GameNavbar.vue';

import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import InputText from 'primevue/inputtext';
import { useAuthStore } from '../stores/auth';
import { storeToRefs } from 'pinia';
import { showVuePopup } from '../utils/showVuePopup';
import Login from '../popup/Login.vue';
import { useToast } from 'primevue/usetoast';
import { openGameUrl } from '../utils/openGameUrl';

export default {
	name: 'Lotto',
	components: {
		IconField,
		InputIcon,
		InputText,
		Button,
		Message,
		GameNavbar,
	},
	setup() {
		const auth = useAuthStore();
		auth.hydrate();
		const { profile } = storeToRefs(auth);

		const toast = useToast();

		const gameType = ref(4); // ประเภทหวย
		const error = ref<string | null>(null);
		const loadingProducts = ref(true);

		const gameState = ref<GameStatusResult>({
			card: false,
			casino: false,
			cock: false,
			esport: false,
			fish: false,
			keno: false,
			lotto: false,
			poker: false,
			slot: false,
			sport: false,
			trade: false,
		});

		const selectedProduct = ref<GamesList | null>(null);
		const products = ref<GamesList[]>([]);

		const searchQuery = ref('');

		const productsList = computed(() => {
			const q = searchQuery.value.toLowerCase();
			return products.value.filter((product) =>
				product.productName?.toLowerCase().includes(q)
			);
		});

		const handleGameStatus = async () => {
			try {
				const resp = await game.status();

				if (resp.code !== '0') throw new Error(resp.message);

				gameState.value = resp.result as GameStatusResult;
			} catch (err: any) {
				error.value = err.message ?? 'ไม่สามารถโหลดสถานะเกมได้';
			}
		};

		const handleProducts = async (type: number) => {
			loadingProducts.value = true;
			error.value = null;

			try {
				const payload = { gameType: type, showGames: true };
				const resp = await game.listByType(payload);

				if (resp.code !== '0') throw new Error(resp.message);

				const result = resp.result as ListByGameTypeResult;

				products.value = result.gamesList || [];
				selectedProduct.value = products.value[0] ?? null;
			} catch (err: any) {
				error.value = err.message ?? 'ไม่สามารถโหลดรายการหวยได้';
			} finally {
				loadingProducts.value = false;
			}
		};

		const clickGame = async (loginCode: string) => {
			if (!auth.isLoggedIn) {
				await showVuePopup(
					Login,
					{},
					{
						customClass: {
							popup:
								'bg-[url(https://snc168.sgp1.cdn.digitaloceanspaces.com/theme/bg-login.webp)] bg-size-[110%_100%] bg-center bg-transparent',
						},
					}
				);
				return;
			}

			// หาเกมจาก products (รายการที่โหลดมา)
			const found = products.value.find((g) => g.loginCode === loginCode) ?? null;

			if (!found) {
				error.value = 'ไม่พบข้อมูลเกมที่เลือก';
				return;
			}

			try {
				const payload = {
					gameType: gameType.value,
					productCode: found.productCode,
					code: loginCode,
					redirect: window.location.origin,
					isMobile: true,
				};

				const resp = await game.login(payload);

				if (resp.code !== '0') throw new Error(resp.message);

				openGameUrl(resp?.url || window.location.origin, (target) => window.location.replace(target));
			} catch (err: any) {
				error.value = err.message ?? 'ไม่สามารถเข้าเกมได้';
			}
		};

		onMounted(async () => {
			await handleGameStatus();
			await handleProducts(gameType.value);
		});

		return {
			auth,
			gameType,
			productsList,
			searchQuery,
			selectedProduct,
			clickGame,
			error,
			loadingProducts,
		};
	},
};
